/* eslint-disable react-hooks/exhaustive-deps */
import {
  Close,
  ContentCopy,
  TrendingUp,
  DeleteOutline,
  PersonAdd,
  CloudUpload,
} from "@mui/icons-material";
import { ConfirmDialog } from "../../components/Dialogs/ConfirmDialog";
import {
  Box,
  Button,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Snackbar,
  Alert,
  Divider,
  Chip,
} from "@mui/material";
import React, { useMemo, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PageContainer } from "../../components/container/PageContainer";
import { config } from "../../config";
import { CustomChip } from "../../components/CustomChip";
import {
  ControlledCustomSelect,
  CustomTextField,
  DebouncedTextField,
} from "../../components/formsComponents";
import { StandardTableActions } from "../../components/StandardTableActions/StandardTableActions";
import { DataTableV2 } from "../../components/TableV2/DataTableV2";
import {
  IDataTableV2State,
  useTableV2State,
} from "../../components/TableV2/hooks/useTableV2State";
import {
  DataTableV2RowRenderType,
  IDataTableV2Props,
} from "../../components/TableV2/interfaces/IDataTableV2Props";
import {
  ALLOWED_MODULES,
  LoadState,
  MODULE_NAMES,
} from "../../constants/enums";
import { createTabsWithRecordcountsV2 } from "../../helpers";
import { getStatusChipColors, IStatusChipColors } from "../../utils/colorUtils";
import { useDispatchWrapper, useRecordCounts } from "../../hooks";
import {
  clearRecordCounts,
  fetchRecordCountsAsync,
} from "../../redux/common/commonActions";
import { IStoreState } from "../../redux/initialStoreState";
import { ILead, IMultipleEvent } from "../../redux/leads/leads.types";
import {
  clearLeadsState,
  fetchLeadAsync,
  fetchLeadListStatusCountAsync,
  fetchLeadsListAsync,
  fetchRoughEstimateAsync,
  fetchRoughEstimateByMultipleEventsAsync,
  fetchDriveStatusCategoryListAsync,
} from "../../redux/leads/leadsActions";
import { ViewLeadDetails } from "./components/ViewLeadDeatils/ViewLeadDetails";
import {
  SEARCH_FIELDS_MAX_WIDTH_SX,
  STANDARD_APP_DATE_FORMAT,
  TABLE_CACHING_KEYS,
} from "../../constants/constants";
import moment from "moment";
import { VenueAutoSearch } from "../../components/AutoCompleteSearches/VenueAutoSearch";
import { EventTypeAutoSearch } from "../../components/AutoCompleteSearches/EventTypeAutoSearch";
import { MasterStatusAutoSearch } from "../../components/AutoCompleteSearches/MasterStatusAutoSearch";
import { LeadSourceAutoSearch } from "../../components/AutoCompleteSearches/LeadSourceAutoSearch";
import { PriorityFilter } from "../../components/AutoCompleteSearches/PriorityFilter";
import { UsersAutoSearch } from "../../components/AutoCompleteSearches/UsersAutoSearch";
import { CustomDatePicker } from "../../components/formsComponents/CustomDatePicker";
import { EditLeadDetails } from "../dashboard/Dashboard/components/ViewLeadDeatils/EditLeadDetails";
import { ViewWhatsappDetails } from "./components/viewWhatsappDetails";
import { FunctionDateFilter } from "./components/FunctionDateFilter";
import { ViewHistoryDetailsRightPanel } from "./LeadHistory/viewHistoryDetails";
import EditIcon from "@mui/icons-material/Edit";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import produce from "immer";
import { DataTableV2MobileFilter } from "../../components/TableV2/components/mobileDataTableV2CommandBar/MobileFilter";
import HistoryIcon from "@mui/icons-material/History";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { api } from "../../api/api";
import { endPoints } from "../../constants/endPoints";
import { CSVNew } from "../../components/TableV2/preDefinedPlugins/CSVExportV2/CSVNew";
import { useBillingCompanyContext } from "../../providers";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { useRoles } from "../../security/RolesProvider/RolesProvider";
import { ViewLeadFoodMenuRightPanel } from "./LeadFoodMenu/ViewLeadFoodMenuRightPanel";
import { OrderProvider } from "../Food/MenuAndOrders/OrderMenu/MenuOrder/OrderContext";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../redux/messages/messagesActions";
import { ManageRoughEstimate } from "./components/RoughEstimate/RoughEstimate";
import { RightPanel } from "../../components/RightPanel";
import { IEventLeadsOptions } from "./ManageLead";
import { useDebounce, useDebounceWithTrigger } from "../../hooks/useDebounce";
import QuickEditLead from "./CompactLeadView/QuickEditLead";
import { DataTableV2Date } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date";
import { getDataTablev2InitialDate } from "../../components/TableV2/helpers/dataTableV2DatesFilter";
import { DataTableV2QuickSearch } from "../../components/TableV2/preDefinedPlugins/DataTableV2QuickSearch/DataTableV2QuickSearch";
import { buildLeadsAdvanceFilter } from "./helpers/leadsFilterHelper";
import { EditCustomerRightPanel } from "../customers/EditCustomer";
import {
  EventChip,
  SourceEventChip,
} from "../../components/ChipsRenderer/EventChip";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";
import { capitalize } from "lodash";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { clearStudent } from "../../redux/student/studentActions";
import { VenueMultipleAutoSearch } from "../../components/AutoCompleteSearches/VenueMultipleAutoSearch";
import { useTimezoneFormatter } from "../../hooks/useTimezoneFormatter";
import {
  DialerCallButton,
  DialerCallDialog,
  useDialerCall,
} from "./components/DialerCallButton";
import { useAuth } from "../../contexts/AuthProvider";
import { AssignUserDialog } from "./components/AssignUserDialog";
import { LeadStatusRenderer } from "../../components/LeadStatusRenderer/LeadStatusRenderer";
import { RoleBasedSecurityButton } from "../../security/RoleBasedComponents/RoleBasedSecurityButton/RoleBasedSecurityButton";
import { BulkUploadLeadsRightPanel } from "./dialogs/BulkUploadLeadsRightPanel";

// ─── Constants ────────────────────────────────────────────────────────────────

export const dateDropdownList = [
  { label: "This Month", value: "thisMonth" },
  { label: "Last 30 Days", value: "last30Days" },
  { label: "Last 3 Months", value: "last3Months" },
  { label: "Last 6 Months", value: "last6Months" },
  { label: "This Year", value: "thisYear" },
  { label: "Customize", value: "custom" },
];

const MONTH_LIST = [
  { label: "January", value: "01" },
  { label: "February", value: "02" },
  { label: "March", value: "03" },
  { label: "April", value: "04" },
  { label: "May", value: "05" },
  { label: "June", value: "06" },
  { label: "July", value: "07" },
  { label: "August", value: "08" },
  { label: "September", value: "09" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
];

const YEAR_OPTIONS = [
  ...Array.from({ length: 9 }, (_, i) => ({
    label: `202${i + 1}`,
    value: `202${i + 1}`,
  })),
  { label: "2030", value: "2030" },
];

const CSV_COLUMNS = [
  { columnName: "Name", fieldName: "name_of_guest", width: 20 },
  { columnName: "Contact No", fieldName: "contact_number_one", width: 20 },
  { columnName: "Event Type", fieldName: "event_type", width: 20 },
  { columnName: "Event Time", fieldName: "event_time", width: 20 },
  { columnName: "Followup Date", fieldName: "followup_date", width: 20 },
  { columnName: "Event Date", fieldName: "function_date", width: 20 },
  { columnName: "Status", fieldName: "status", width: 20 },
  { columnName: "Guests", fieldName: "number_of_guests", width: 20 },
  { columnName: "Preferred Venue", fieldName: "preferred_venue", width: 20 },
  {
    columnName: "Handled By Employee",
    fieldName: "handled_by_employee",
    width: 20,
  },
  { columnName: "Created At", fieldName: "create_ts", width: 20 },
  { columnName: "Remarks", fieldName: "remark", width: 40 },
];

// When rendered from the dashboard count cards, the table fetches via the
// status-count API and only exposes the CSV download in the command bar.
export interface ILeadsDashboardConfig {
  statusParam: string;
  monthType: string;
  dateState: { dates: { fromDate: string; toDate: string } };
}

// ─── Component ────────────────────────────────────────────────────────────────

export const Leads: React.FC<{ dashboardConfig?: ILeadsDashboardConfig }> = ({
  dashboardConfig,
}) => {
  const isDashboard = Boolean(dashboardConfig);
  const tableRef = useRef<HTMLDivElement>(null);
  const isInitialLoad = useRef(true);
  const historyStatusParamRef = useRef("");
  const { roles } = useRoles();
  const { country } = useAuth();
  const dispatch = useDispatchWrapper();
  const navigate = useNavigate();
  const companyOutlet = useBillingCompanyContext();
  const { ftDateTime, ftDate } = useTimezoneFormatter();
  const { dialerState, initiateCall, closeDialog } = useDialerCall();

  const accessibleModuleIds = useMemo(
    () => roles.filter((m) => m.show_module === 1).map((m) => m.module_key),
    [roles],
  );

  const { list: recordsCounts, loading: recordCountsLoading } =
    useRecordCounts();
  const { list, loading, totalRecords } = useSelector(
    (s: IStoreState) => s.leads.list,
  );
  const { data: requestedLeadData } = useSelector(
    (s: IStoreState) => s.leads.lead,
  );
  const { list: driveStatusCategoryList } = useSelector(
    (s: IStoreState) => s.leads.driveStatusCategoryList,
  );

  // Sub-status name -> colour (falls back to the parent category colour), and
  // the list of category options, both derived from the drive status
  // category list (same source EditStatus.tsx uses to manage these colours).
  // Light sub-status colours become the chip background with master-coloured
  // text (see getStatusChipColors).
  const statusColorMap = useMemo(() => {
    const map: Record<string, IStatusChipColors> = {};
    (driveStatusCategoryList || []).forEach((category: any) => {
      const categoryColor = category.label_colour;
      const categoryColors = getStatusChipColors(categoryColor, categoryColor);
      if (category.master_status_name && categoryColors) {
        map[category.master_status_name.toUpperCase()] = categoryColors;
      }
      (category.drive_status || []).forEach((ds: any) => {
        const colors = getStatusChipColors(
          ds?.label_colour || categoryColor,
          ds?.master_label_colour || categoryColor,
        );
        if (ds?.name && colors) {
          map[ds.name.toUpperCase()] = colors;
        }
      });
    });
    return map;
  }, [driveStatusCategoryList]);

  const statusCategoryOptions = useMemo(
    () => [
      { label: "All", value: "-1" },
      ...(driveStatusCategoryList || [])
        .filter((category: any) => category.master_status_name)
        .map((category: any) => ({
          label: capitalize(category.master_status_name),
          value: capitalize(category.master_status_name),
        })),
    ],
    [driveStatusCategoryList],
  );

  const getStatusChipColor = useCallback(
    (status?: string | null, actualStatus?: string | null): IStatusChipColors =>
      statusColorMap[(status || "").toUpperCase()] ||
      statusColorMap[(actualStatus || "").toUpperCase()] || {
        text: "#757575",
        bg: "#75757520",
        border: "#757575",
      },
    [statusColorMap],
  );

  const renderStatusChip = useCallback(
    (row: ILead) => {
      const { text, bg, border } = getStatusChipColor(
        row.status,
        row.actual_status,
      );
      return (
        <CustomChip
          color="primary"
          content={row.status ? capitalize(row.status) : "--"}
          size="small"
          sx={{
            color: text,
            bgcolor: bg,
            borderColor: border,
            "& .MuiChip-label": { color: text },
          }}
        />
      );
    },
    [getStatusChipColor],
  );

  // ─── Refs ─────────────────────────────────────────────────────────────────
  const venueAutoSearchRef = useRef<{ clear: () => void }>(null);
  const eventTypeAutoSearchRef = useRef<{ clear: () => void }>(null);
  const leadSourceAutoSearchRef = useRef<{ clear: () => void }>(null);

  // ─── Panel State ──────────────────────────────────────────────────────────
  const [openView, setOpenView] = React.useState<ILead | null>(null);
  const [openEdit, setOpenEdit] = React.useState<ILead | null>(null);
  const [openQuickEdit, setOpenQuickEdit] = React.useState<ILead | null>(null);
  const [openEditCustomer, setOpenEditCustomer] = React.useState<ILead | null>(
    null,
  );
  const [openRoughEstimate, setRoughEstimate] = React.useState<ILead | null>(
    null,
  );
  const [openWhatsapp, setOpenWhatsapp] = React.useState<ILead | null>(null);
  const [openHistory, setOpenHistory] = React.useState<ILead | null>(null);
  const [openFoodMenu, setOpenFoodMenu] = React.useState<ILead | null>(null);
  const [leadToDelete, setLeadToDelete] = React.useState<ILead | null>(null);
  const [deleteErrorMsg, setDeleteErrorMsg] = React.useState<string | null>(
    null,
  );
  const [selectedLeads, setSelectedLeads] = React.useState<ILead[]>([]);
  const [assignUserDialogOpen, setAssignUserDialogOpen] = React.useState(false);
  const [openBulkUpload, setOpenBulkUpload] = React.useState<boolean>(false);

  // ─── Table State ──────────────────────────────────────────────────────────
  const {
    state,
    setSelectedTab,
    setDateState,
    setTableTabs,
    setSearchState,
    setColumnVisibility,
    onPageChange,
    onRowsPerPageChange,
    onResizeMasterColumns,
    resetState,
    onMobileStateChange,
    initialColumnVisibility,
    resetPaginationToInitialPagination,
  } = useTableV2State({
    filtersInitialState: {
      defaultDateRange: "last30Days",
      selectedTab: "-1",
    },
    pagination: isDashboard
      ? {
          pageNumber: 1,
          rowsInPerPage: 10,
          apiFetchRowCount: 11,
          extraFetchFactor: 1,
        }
      : {
          pageNumber: 1,
          rowsInPerPage: 25,
          apiFetchRowCount: 26,
          extraFetchFactor: 1,
        },
    cachingFilters: {
      uniqueKey: isDashboard
        ? TABLE_CACHING_KEYS.LEAD_TABLE_COUNT
        : TABLE_CACHING_KEYS.EVENT_LEADS,
    },
    otherCustomStateProperties: {
      searchByNameOrNumber: "",
      searchByVenue: "",
      selectedTab: "-1",
      followupDate: null,
      searchByIsReplied: false,
      searchByEventType: null,
      searchByLeadSource: null,
      searchByPriority: "",
      searchByHandledBy: null,
      functionDate: null,
      functionMonth: null,
      functionYear: null,
    },
  });

  const {
    dateState,
    searchState,
    tabs,
    columnsConfig,
    pagination,
    masterColumnResize,
    otherCustomStateProperties,
  } = state;

  // ─── Debounced Values ─────────────────────────────────────────────────────
  const [debouncedSearchNameOrNumber, searchVersion] = useDebounceWithTrigger(
    otherCustomStateProperties.searchByNameOrNumber,
    500,
  );
  const debouncedSearchVenue = useDebounce(
    otherCustomStateProperties.searchByVenue,
    500,
  );
  const debouncedEventName = useDebounce(
    otherCustomStateProperties.other_event_name,
    500,
  );

  // ─── Derived ──────────────────────────────────────────────────────────────
  const eventOptionsForPaymentDetails: IEventLeadsOptions[] = useMemo(
    () =>
      requestedLeadData?.multiple_events_list?.map((item: IMultipleEvent) => ({
        eventName: item.other_event_name || "",
        eventType: item.event_type,
        leadUuid: item.leads_uuid || "",
        leadStatus: item.status || "",
        contactNumber: requestedLeadData.contact_number_one || "",
        leadData: item as ILead,
      })) || [],
    [requestedLeadData],
  );

  const isFilterApplied = useMemo(() => {
    return Boolean(
      otherCustomStateProperties.searchByNameOrNumber ||
      otherCustomStateProperties.searchByVenue ||
      otherCustomStateProperties.followupDate ||
      otherCustomStateProperties.functionDate ||
      otherCustomStateProperties.searchByEventName ||
      otherCustomStateProperties.functionMonth ||
      otherCustomStateProperties.functionYear ||
      otherCustomStateProperties.searchByEventType?.length > 0 ||
      otherCustomStateProperties.searchByIsReplied ||
      otherCustomStateProperties.searchByLeadSource ||
      otherCustomStateProperties.searchByPriority ||
      tabs.selectedTab !== "-1" ||
      dateState.filterBy === "create_ts" || 
      dateState.rangeType !== "last30Days",
    );
  }, [otherCustomStateProperties, tabs.selectedTab, dateState.rangeType, dateState.filterBy]);

  // ─── Handlers ─────────────────────────────────────────────────────────────

  const handleCopyPhoneNumber = useCallback(
    async (phoneNumber: string) => {
      try {
        await navigator.clipboard.writeText(phoneNumber);
        dispatch(
          showMessage({
            type: "success",
            displayAs: "snackbar",
            message: "Phone number copied!",
          }),
        );
      } catch {
        dispatch(
          showMessage({
            type: "error",
            displayAs: "snackbar",
            message: "Failed to copy phone number",
          }),
        );
      }
    },
    [dispatch],
  );

  const handleCreate = useCallback(
    () => navigate("/event-leads/manage"),
    [navigate],
  );

  const handleExportStart = useCallback(
    () => dispatch(saveLoaderProgress()),
    [dispatch],
  );
  const handleExportComplete = useCallback(
    () => dispatch(saveLoaderCompleted()),
    [dispatch],
  );

  const setFilterStateSync = useCallback(
    (value: React.SetStateAction<IDataTableV2State>) => {
      const prev = state;
      const resolved =
        typeof value === "function" ? (value as any)(prev) : value;
      const isSameDateState =
        resolved.dateState?.rangeType === "allTimes" &&
        !resolved.dateState?.dates?.fromDate &&
        !resolved.dateState?.dates?.toDate;
      const next = isSameDateState
        ? resolved
        : {
            ...resolved,
            dateState: {
              rangeType: "allTimes",
              dates: { fromDate: "", toDate: "" },
            },
          };
      // Persist to cache/server (was raw setState before, which never saved
      // custom filters like venue/source/follow-up/priority/handled-by).
      onMobileStateChange(next);
    },
    [state, onMobileStateChange],
  );

  const handleCustomFilterChange = useCallback(
    (key: string, value: any) => {
      const newState = produce(state, (draft) => {
        draft.otherCustomStateProperties[key] = value;
      });
      setFilterStateSync(newState);
    },
    [state, setFilterStateSync],
  );

  const getFilters = useCallback(
    () => buildLeadsAdvanceFilter(otherCustomStateProperties),
    [otherCustomStateProperties],
  );

  const fetchList = useCallback(() => {
    if (dashboardConfig) {
      const { statusParam, monthType } = dashboardConfig;
      if (!statusParam) return;
      if (historyStatusParamRef.current !== statusParam) {
        historyStatusParamRef.current = statusParam;
        // Pagination reset triggers its own refetch via the effect below.
        if (resetPaginationToInitialPagination()) return;
      }
      dispatch(
        fetchLeadListStatusCountAsync(
          "list",
          monthType,
          statusParam,
          pagination.pageNumber,
          pagination.rowsInPerPage,
          pagination.apiFetchRowCount,
          searchState,
          companyOutlet.comapny.company_outlet_uuid,
        ),
      );
      return;
    }
    const filters = getFilters();
    dispatch(
      fetchLeadsListAsync({
        page: pagination.pageNumber,
        rowsPerPage: pagination.rowsInPerPage,
        pageLimit: pagination.apiFetchRowCount,
        status: tabs.selectedTab,
        advanceFilter: [...searchState, ...filters],
        date: dateState.dates,
        filterBy: dateState.filterBy,
        multiple_events: 0,
        unreplied_messages:
          otherCustomStateProperties.searchByIsReplied || undefined,
      }),
    );
  }, [
    dispatch,
    pagination,
    tabs.selectedTab,
    searchState,
    dateState.dates,
    dateState.filterBy,
    otherCustomStateProperties,
    getFilters,
    dashboardConfig?.statusParam,
    dashboardConfig?.monthType,
    companyOutlet.comapny.company_outlet_uuid,
    resetPaginationToInitialPagination,
  ]);

  const handleRoughEstimateClick = useCallback(
    async (rowData: ILead) => {
      if (!rowData?.leads_uuid) {
        dispatch(
          showMessage({
            type: "error",
            message: "Please select a lead to open quotation",
            displayAs: "snackbar",
          }),
        );
        return;
      }
      dispatch(saveLoaderProgress());
      try {
        await Promise.all([
          dispatch(
            fetchLeadAsync({
              multiple_events_uuid: rowData.multiple_events_uuid || "",
              company_outlet_uuid: companyOutlet.comapny.company_outlet_uuid,
              skipLoader: true,
            }),
          ),
          dispatch(
            rowData.multiple_events_uuid
              ? fetchRoughEstimateByMultipleEventsAsync(
                  rowData.multiple_events_uuid,
                  true,
                )
              : fetchRoughEstimateAsync(rowData.leads_uuid, 0, undefined, true),
          ),
        ]);
      } finally {
        dispatch(saveLoaderCompleted());
      }
      setRoughEstimate(rowData);
    },
    [dispatch, companyOutlet.comapny.company_outlet_uuid],
  );

  const handleDeleteLead = useCallback(
    async (row: ILead) => {
      try {
        dispatch(saveLoaderProgress());
        await api.delete(
          `/leads/delete-multiple-leads?multiple_events_uuid=${row.multiple_events_uuid}`,
        );
        dispatch(
          showMessage({
            type: "success",
            message: "Lead deleted successfully",
            displayAs: "snackbar",
          }),
        );
        fetchList();
        if (!isDashboard) {
          dispatch(
            fetchRecordCountsAsync({
              tableName: "latest_leads",
              module_key: ALLOWED_MODULES.EVENT_LEADS,
              fromDate: dateState.dates.fromDate,
              toDate: dateState.dates.toDate,
              companyOutlet: companyOutlet.comapny.company_outlet_uuid,
              searchValue: getFilters(),
            }),
          );
        }
      } catch (err: any) {
        if (err.response?.status === 400) {
          setDeleteErrorMsg(
            err.response?.data?.message ||
              "Cannot delete — some leads are BOOKED or HOLD.",
          );
        } else {
          dispatch(
            showMessage({
              type: "error",
              message: err.response?.data?.message || "Failed to delete lead",
              displayAs: "snackbar",
            }),
          );
        }
      } finally {
        dispatch(saveLoaderCompleted());
      }
    },
    [
      dispatch,
      fetchList,
      getFilters,
      isDashboard,
      dateState.dates,
      companyOutlet.comapny.company_outlet_uuid,
    ],
  );

  const fetchAllData = useCallback(async () => {
    try {
      if (dashboardConfig) {
        const { statusParam, dateState: dashboardDateState } = dashboardConfig;
        const dashboardURL = `${endPoints.leads.statusLead}?remark_needed=true&pageNo=1&pageLimit=10000&itemPerPage=10000&from_date=${dashboardDateState.dates.fromDate}&to_date=${dashboardDateState.dates.toDate}&status_type=${statusParam}&data_wise=Enquiry_Month&type=list&company_outlet_uuid=${companyOutlet.comapny.company_outlet_uuid}`;
        const res = await api.get(dashboardURL);
        return res.data?.data?.leadList || [];
      }
      let apiURL = `${endPoints.leads.fetchleads}?remark_needed=true`;
      if (dateState.dates.fromDate && dateState.dates.toDate) {
        apiURL += `&from_date=${dateState.dates.fromDate}&to_date=${dateState.dates.toDate}`;
      }
      if (tabs.selectedTab && tabs.selectedTab !== "-1") {
        apiURL += `&status=${tabs.selectedTab}`;
      }
      if (companyOutlet.comapny.company_outlet_uuid) {
        apiURL += `&company_outlet_uuid=${companyOutlet.comapny.company_outlet_uuid}`;
      }
      const filters = getFilters();
      if (filters.length > 0) {
        apiURL += `&advanceFilter=${encodeURIComponent(JSON.stringify(filters))}`;
      }
      if (otherCustomStateProperties.searchByIsReplied) {
        apiURL += `&unreplied_messages=${otherCustomStateProperties.searchByIsReplied}`;
      }
      const res = await api.get(apiURL);
      return res.data?.data || [];
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response?.data?.message || "Export failed",
          displayAs: "snackbar",
        }),
      );
      return [];
    }
  }, [
    dateState.dates,
    tabs.selectedTab,
    companyOutlet.comapny.company_outlet_uuid,
    otherCustomStateProperties.searchByIsReplied,
    getFilters,
    dispatch,
    dashboardConfig,
  ]);

  const handleAssignUserComplete = useCallback(() => {
    setSelectedLeads([]);
    fetchList();
  }, [fetchList]);

  const handleClearFilters = useCallback(() => {
    if (!isFilterApplied) return;
    resetState();
    venueAutoSearchRef.current?.clear();
    eventTypeAutoSearchRef.current?.clear();
    leadSourceAutoSearchRef.current?.clear();
    const cleared = produce(state, (draft) => {
      draft.dateState.rangeType = "last30Days";
      draft.dateState.filterBy = "insert_ts";
      draft.dateState.dates = { ...getDataTablev2InitialDate("last30Days") };
      draft.tabs.selectedTab = "-1";
      draft.otherCustomStateProperties.searchByNameOrNumber = "";
      draft.otherCustomStateProperties.searchByVenue = "";
      draft.otherCustomStateProperties.followupDate = null;
      draft.otherCustomStateProperties.functionDate = null;
      draft.otherCustomStateProperties.searchByEventName = "";
      draft.otherCustomStateProperties.searchByEventType = null;
      draft.otherCustomStateProperties.searchByLeadSource = null;
      draft.otherCustomStateProperties.searchByPriority = "";
      draft.otherCustomStateProperties.searchByHandledBy = null;
      draft.otherCustomStateProperties.functionMonth = null;
      draft.otherCustomStateProperties.functionYear = null;
      draft.otherCustomStateProperties.searchByIsReplied = false;
      draft.pagination.pageNumber = 1;
    });
    // Persist the cleared state so it survives reload/login.
    onMobileStateChange(cleared);
  }, [isFilterApplied, resetState, state, onMobileStateChange]);

  // ─── Reusable Cell Renderers ──────────────────────────────────────────────

  const renderContactCell = useCallback(
    (row: ILead) => (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <DialerCallButton
          phoneNumber={`${row.country_code || country.dialCode}${row.contact_number_one}`}
          onCall={initiateCall}
          disabled={dialerState.loading}
        />
        <WhatsAppIcon
          sx={{
            cursor: "pointer",
            color: "#25D366",
            fontSize: "1.2rem",
          }}
          onClick={(e) => {
            e.stopPropagation();
            setOpenWhatsapp(row);
          }}
        />
        <Typography variant="body2">
          {`${row.country_code || ""} ${row.contact_number_one}`}
        </Typography>
      </Box>
    ),
    [country.dialCode, initiateCall, dialerState.loading],
  );

  const renderMobileContactCell = useCallback(
    (row: ILead) => (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <DialerCallButton
          phoneNumber={`${row.country_code || country.dialCode}${row.contact_number_one}`}
          onCall={initiateCall}
          disabled={dialerState.loading}
        />
        <WhatsAppIcon
          sx={{
            cursor: "pointer",
            color: "#25D366",
            fontSize: { xs: "1.1rem", sm: "1.2rem" },
          }}
          onClick={(e) => {
            e.stopPropagation();
            setOpenWhatsapp(row);
          }}
        />
        <Typography
          variant="body2"
          sx={{
            color: "#1e293b",
            fontSize: "0.85rem",
            fontWeight: 600,
          }}
        >
          {row.country_code || country.dialCode}
          {row.contact_number_one}
        </Typography>
      </Box>
    ),
    [country.dialCode, initiateCall, dialerState.loading],
  );

  const renderEventDate = useCallback(
    (row: ILead) => {
      if (!row.function_date) return "--";
      const formattedDate = ftDate(row.function_date);
      if (row.event_type === "WEDDING") {
        return (
          <CustomChip
            content={formattedDate}
            size="small"
            sx={{ color: "#ff8c03", bgcolor: "#fff1e0" }}
          />
        );
      }
      return formattedDate;
    },
    [ftDate],
  );

  const renderFollowupDate = useCallback(
    (row: ILead) => {
      if (!row.followup_date) return "--";
      const finalDate = ftDate(row.followup_date);
      const isToday = finalDate === moment().format(STANDARD_APP_DATE_FORMAT);
      return (
        <Typography sx={{ color: isToday ? "error.main" : "" }}>
          {finalDate}
        </Typography>
      );
    },
    [ftDate],
  );

  // ─── Table Props ──────────────────────────────────────────────────────────

  const dashboardCommandBarProps: IDataTableV2Props["tableCommandBarProps"] = {
    preDefinedPlugins: {},
    leftItems: { customPlugins: [] },
    rightItems: {
      customPlugins: [
        {
          key: "csvExport",
          onRender: () => (
            <CSVNew
              columns={CSV_COLUMNS}
              onExportButtonClick={fetchAllData}
              onExportStart={handleExportStart}
              onExportComplete={handleExportComplete}
              filePrefixName="Leads Report"
            />
          ),
        },
      ],
    },
  };

  const leadsTableProps: IDataTableV2Props = {
    isPagination: true,
    selectionMode: "none",
    uniqueRowKeyName: "leads_uuid",
    // totalRecords,
    pageNumber: pagination.pageNumber,
    rowsPerPageOptions: pagination.rowsInPerPage,
    extraFetchFactor: pagination.extraFetchFactor,
    isDataLoading: loading === LoadState.InProgress,
    onSeeAllDetails: (r: ILead) =>
      navigate(
        `${REACT_APP_NAV_ROUTES.leads.EventLeads}/manage/${r.leads_uuid}/${r.multiple_events_uuid}`,
      ),
    onCopyPhone: (phone: string) => handleCopyPhoneNumber(phone),
    onWhatsappClick: (r: ILead) => setOpenWhatsapp(r),
    showCreateButton: !isDashboard &&
      !(loading === LoadState.InProgress) &&
      list.length === 0 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            sx={{ ml: 1 }}
            color="success"
            variant="contained"
            onClick={handleCreate}
          >
            Create Lead
          </Button>
        </Box>
      ),

    // ─── Desktop Command Bar ──────────────────────────────────────────────
    tableCommandBarProps: isDashboard ? dashboardCommandBarProps : {
      customCommandBar: (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            gap: 1,
            alignItems: "flex-start",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              columnGap: 1,
              rowGap: 1.5,
              flex: 1,
              minWidth: 0,
              // Back every field's floating label onto white so the label
              // notch matches (CustomTextField labels inherit --parent-bg,
              // which resolves to the grey layout bg otherwise).
              // "--parent-bg": "#ffffff",
            }}
          >
            <DataTableV2Date
              state={dateState}
              onChange={setDateState}
              isHighlighted={dateState.rangeType !== "last30Days"}
              sx={SEARCH_FIELDS_MAX_WIDTH_SX}
              showFilterByToggle
            />

            <Box sx={SEARCH_FIELDS_MAX_WIDTH_SX}>
              {/* Replaced by the ControlledCustomSelect below, driven by
                  fetchDriveStatusCategoryListAsync instead of a live search. */}
              {/* <MasterStatusAutoSearch
                label="Select Status"
                company_outlet_uuid={companyOutlet.comapny.company_outlet_uuid}
                value={capitalize(tabs.selectedTab) || ""}
                onSelect={(newValue) => {
                  const name = newValue?.name;
                  setSelectedTab(!name || name === "All" || name === "-1" ? "-1" : capitalize(name));
                }}
                isHighlighted={tabs.selectedTab !== "-1"}
                placeholder="Search status..."
                showAllOption={true}
              /> */}
              <ControlledCustomSelect
                label="Select Status"
                name="selectedTab"
                fullWidth
                displayEmpty
                value={tabs.selectedTab || "-1"}
                onChange={(e) =>
                  setSelectedTab((e.target.value as string) || "-1")
                }
                options={statusCategoryOptions}
                highlight={tabs.selectedTab !== "-1"}
              />
            </Box>

            <Box position="relative" sx={SEARCH_FIELDS_MAX_WIDTH_SX}>
              <VenueMultipleAutoSearch
                fullWidth
                ref={venueAutoSearchRef}
                label="Search by Venue"
                multiple
                value={otherCustomStateProperties.searchByVenue || []}
                onSelect={(venue) =>
                  handleCustomFilterChange("searchByVenue", venue)
                }
                isHighlighted={
                  otherCustomStateProperties.searchByVenue?.length > 0
                }
              />
              {/* Clearing is handled by the built-in clear icon (onSelect([])). */}
            </Box>

            <Box position="relative" sx={SEARCH_FIELDS_MAX_WIDTH_SX}>
              <CustomDatePicker
                placeholder="Follow-up Date"
                value={otherCustomStateProperties.followupDate}
                onChange={(newValue) =>
                  handleCustomFilterChange("followupDate", newValue)
                }
                fullWidth
                highlight={otherCustomStateProperties.followupDate}
                // sx={
                //   otherCustomStateProperties.followupDate
                //     ? {
                //         backgroundColor: "#fff2c7",
                //         borderRadius: 1,
                //         "& .MuiOutlinedInput-notchedOutline": {
                //           borderColor: "warning.main",
                //           borderWidth: "2px !important",
                //         },
                //         "&:hover .MuiOutlinedInput-notchedOutline": {
                //           borderColor: "warning.main",
                //         },
                //         "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                //           borderColor: "warning.main",
                //         },
                //       }
                //     : undefined
                // }
              />
              {otherCustomStateProperties.followupDate && (
                <IconButton
                  size="small"
                  onClick={() => handleCustomFilterChange("followupDate", null)}
                  sx={{
                    position: "absolute",
                    right: 26,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 1,
                  }}
                >
                  <Close fontSize="small" />
                </IconButton>
              )}
            </Box>

            <FunctionDateFilter
              sx={SEARCH_FIELDS_MAX_WIDTH_SX}
              value={{
                functionDate: otherCustomStateProperties.functionDate,
                functionMonth: otherCustomStateProperties.functionMonth,
                functionYear: otherCustomStateProperties.functionYear,
              }}
              onChange={(dateState) => {
                const newState = produce(state, (draft) => {
                  draft.otherCustomStateProperties.functionDate =
                    dateState.functionDate;
                  draft.otherCustomStateProperties.functionMonth =
                    dateState.functionMonth;
                  draft.otherCustomStateProperties.functionYear =
                    dateState.functionYear;
                });
                setFilterStateSync(newState);
              }}
            />

            <Box position="relative" sx={SEARCH_FIELDS_MAX_WIDTH_SX}>
              <LeadSourceAutoSearch
                ref={leadSourceAutoSearchRef}
                label="Search by Source"
                value={
                  otherCustomStateProperties.searchByLeadSource
                    ?.lead_source_uuid || ""
                }
                source_name={
                  otherCustomStateProperties.searchByLeadSource?.source_name ||
                  ""
                }
                onSelect={(ls) =>
                  handleCustomFilterChange(
                    "searchByLeadSource",
                    ls?.lead_source_uuid ? ls : null,
                  )
                }
                isHighlighted={
                  !!otherCustomStateProperties.searchByLeadSource
                    ?.lead_source_uuid
                }
                hideAddButton={true}
              />
            </Box>

            <Box position="relative" sx={SEARCH_FIELDS_MAX_WIDTH_SX}>
              <EventTypeAutoSearch
                fullWidth
                ref={eventTypeAutoSearchRef}
                label="Event Type"
                multiple
                value={otherCustomStateProperties.searchByEventType || []}
                onSelect={(eventTypes) =>
                  handleCustomFilterChange("searchByEventType", eventTypes)
                }
                isHighlighted={
                  otherCustomStateProperties.searchByEventType?.length > 0
                }
              />
              {/* Clearing is handled by the Autocomplete's built-in clear icon
                  (onSelect([]) fires on clear). */}
            </Box>

            <Box position="relative" sx={SEARCH_FIELDS_MAX_WIDTH_SX}>
              <PriorityFilter
                isFilter
                value={otherCustomStateProperties.searchByPriority || ""}
                onChange={(val) =>
                  handleCustomFilterChange("searchByPriority", val)
                }
                isHighlighted={!!otherCustomStateProperties.searchByPriority}
              />
            </Box>

            <Box position="relative" sx={SEARCH_FIELDS_MAX_WIDTH_SX}>
              <UsersAutoSearch
                label="Handled By"
                value={
                  otherCustomStateProperties.searchByHandledBy || {
                    user_uuid: "",
                    user_name: "",
                  }
                }
                onSelect={(user) =>
                  handleCustomFilterChange(
                    "searchByHandledBy",
                    user?.user_uuid ? user : null,
                  )
                }
                isHighlighted={
                  !!otherCustomStateProperties.searchByHandledBy?.user_uuid
                }
              />
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              flexShrink: 0,
              ml: "auto",
            }}
          >
            <Tooltip title="Clear Filters">
              <IconButton
                onClick={handleClearFilters}
                size="small"
                sx={{
                  borderRadius: 1,
                  py: "6px",
                  ...(isFilterApplied
                    ? {
                        background: (t) => t.palette.warning.main,
                        "&:hover": { background: "#ffa20f" },
                      }
                    : {
                        background: "transparent",
                        border: "1px solid #e0e0e0",
                      }),
                }}
              >
                <FilterAltOffIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      ),
      preDefinedPlugins: {
        columnVisibility: {
          columnVisibility: columnsConfig.columnVisibility,
          initialColumnVisibility,
          onChange: setColumnVisibility,
        },
        search: {
          tableName: "latest_leads",
          excludeColumnsInSearch: ["view"],
          state: searchState,
          onChange: setSearchState,
          loadInitialFilterOncePopoverOpened: [
            {
              column: ["name_of_guest"],
              logicalOperator: "AND",
              operator: "CONTAINS",
              value: "",
            },
          ],
        },
        refresh: { onClick: fetchList },
        autoFit: true,
      },
      leftItems: { customPlugins: [] },
      centerItems: {
        customPlugins: [
          {
            key: "searchByNameOrNumber",
            onRender: () => (
              <DataTableV2QuickSearch
                value={otherCustomStateProperties.searchByNameOrNumber}
                onChange={(val) =>
                  handleCustomFilterChange("searchByNameOrNumber", val)
                }
                placeholder="Search by Name or Number"
                delay={600}
              />
            ),
          },
        ],
      },
      rightItems: {
        customPlugins: [
          {
            key: "assignUser",
            onRender: () => {
              if (selectedLeads.length === 0) return null;
              return (
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  startIcon={<PersonAdd />}
                  onClick={() => setAssignUserDialogOpen(true)}
                  sx={{ textTransform: "none" }}
                >
                  {`Assign User (${selectedLeads.length})`}
                </Button>
              );
            },
          },
          {
            key: "csvExport",
            onRender: () => {
              if (selectedLeads.length > 0) return null;
              return (
                <CSVNew
                  columns={CSV_COLUMNS}
                  columnVisibility={columnsConfig.columnVisibility}
                  enableColumnSelection={true}
                  rows={list}
                  onExportButtonClick={fetchAllData}
                  onExportStart={handleExportStart}
                  onExportComplete={handleExportComplete}
                  filePrefixName="Leads Report"
                />
              );
            },
          },
          {
            key: "createLead",
            onRender: () => {
              if (selectedLeads.length > 0) return null;
              return (
                <Button
                  sx={{ ml: 1 }}
                  color="success"
                  variant="contained"
                  onClick={handleCreate}
                >
                  Create Lead
                </Button>
              );
            },
          },
          {
            key: "bulkUploadLead",
            onRender: () => {
              if (selectedLeads.length > 0) return null;
              return (
                <RoleBasedSecurityButton
                  moduleId={ALLOWED_MODULES.BULK_UPLOAD_BUTTON}
                  // allowFullAccess
                  sx={{ ml: 1 }}
                  color="primary"
                  variant="contained"
                  startIcon={<CloudUpload />}
                  onClick={() => setOpenBulkUpload(true)}
                >
                  Bulk Upload
                </RoleBasedSecurityButton>
              );
            },
          },
        ],
      },
    },

    // ─── Mobile Command Bar ─────────────────────────────────────────────────
    mobileCommandBarProps: isDashboard ? { filterComponent: <></> } : {
      filterComponent: (
        <DataTableV2MobileFilter
          state={state}
          onApply={(newState) => onMobileStateChange(newState)}
          onClear={handleClearFilters}
          hasFilterApplied={isFilterApplied}
          pageTitle="Leads"
          headerAction={
            <Stack direction="row" spacing={1} alignItems="center">
              <Button
                color="success"
                variant="contained"
                size="small"
                onClick={handleCreate}
                startIcon={<PersonAdd />}
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 700,
                }}
              >
                Create Lead
              </Button>
              {/* <RoleBasedSecurityButton
                moduleId={ALLOWED_MODULES.BULK_UPLOAD_BUTTON}
                color="primary"
                variant="outlined"
                size="small"
                startIcon={<CloudUpload />}
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 700,
                }}
                onClick={() => setOpenBulkUpload(true)}
              >
                Bulk Upload
              </RoleBasedSecurityButton> */}
            </Stack>
          }
          searchValue={otherCustomStateProperties.searchByNameOrNumber || ""}
          onSearchChange={(val) =>
            handleCustomFilterChange("searchByNameOrNumber", val)
          }
          searchPlaceholder="Search leads by name or number..."
          inlineActions={
            <CSVNew
              columns={CSV_COLUMNS}
              columnVisibility={columnsConfig.columnVisibility}
              enableColumnSelection={true}
              onExportButtonClick={fetchAllData}
              onExportStart={handleExportStart}
              onExportComplete={handleExportComplete}
              filePrefixName="Leads Report"
              isMobile={true}
            />
          }
        >
          {(filterLocalState, setFilterlocalState) => (
            <Stack direction="column" spacing={2.5} mt={1} mb={2}>
              {/* Section 1: Quick Search & Date */}
              <Box>
                <Typography
                  variant="subtitle2"
                  fontWeight={700}
                  sx={{
                    color: "#334155",
                    fontSize: "0.85rem",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                    mb: 1.25,
                  }}
                >
                  Date & Keyword
                </Typography>
                <Stack spacing={2}>
                  <DataTableV2Date
                    state={filterLocalState.dateState}
                    onChange={(newDateState) =>
                      setFilterlocalState({
                        ...filterLocalState,
                        dateState: newDateState,
                      })
                    }
                    isHighlighted={
                      filterLocalState.dateState.rangeType !== "last30Days"
                    }
                  />

                  <DebouncedTextField
                    variant="outlined"
                    label="Search by Name or Number"
                    placeholder="Search guest name or mobile number..."
                    fullWidth
                    value={
                      filterLocalState.otherCustomStateProperties
                        .searchByNameOrNumber || ""
                    }
                    onChange={(val) =>
                      setFilterlocalState({
                        ...filterLocalState,
                        otherCustomStateProperties: {
                          ...filterLocalState.otherCustomStateProperties,
                          searchByNameOrNumber: val,
                        },
                      })
                    }
                    delay={600}
                  />
                </Stack>
              </Box>

              <Divider sx={{ borderColor: "#f1f5f9" }} />

              {/* Section 2: Event Details */}
              <Box>
                <Typography
                  variant="subtitle2"
                  fontWeight={700}
                  sx={{
                    color: "#334155",
                    fontSize: "0.85rem",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                    mb: 1.25,
                  }}
                >
                  Event & Venue
                </Typography>
                <Stack spacing={2}>
                  <VenueAutoSearch
                    label="Search by Venue"
                    ref={venueAutoSearchRef}
                    venue_name={
                      filterLocalState.otherCustomStateProperties.searchByVenue
                    }
                    value={
                      filterLocalState.otherCustomStateProperties.searchByVenue
                    }
                    onSelect={(venue) =>
                      setFilterlocalState({
                        ...filterLocalState,
                        otherCustomStateProperties: {
                          ...filterLocalState.otherCustomStateProperties,
                          searchByVenue: venue?.venue_name || null,
                        },
                      })
                    }
                    isHighlighted={
                      !!filterLocalState.otherCustomStateProperties
                        .searchByVenue
                    }
                  />

                  <Stack direction="row" spacing={1.5} sx={{ width: "100%" }}>
                    <Box sx={{ flex: 1 }}>
                      <ControlledCustomSelect
                        label="Event Month"
                        name="month"
                        value={
                          filterLocalState.otherCustomStateProperties
                            .functionMonth || ""
                        }
                        fullWidth
                        onChange={(e) =>
                          setFilterlocalState({
                            ...filterLocalState,
                            otherCustomStateProperties: {
                              ...filterLocalState.otherCustomStateProperties,
                              functionMonth: e.target.value as string,
                              functionYear:
                                filterLocalState.otherCustomStateProperties
                                  .functionYear || moment().year().toString(),
                            },
                          })
                        }
                        options={MONTH_LIST}
                      />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <ControlledCustomSelect
                        label="Event Year"
                        name="year"
                        value={
                          filterLocalState.otherCustomStateProperties
                            .functionYear || ""
                        }
                        fullWidth
                        onChange={(e) =>
                          setFilterlocalState({
                            ...filterLocalState,
                            otherCustomStateProperties: {
                              ...filterLocalState.otherCustomStateProperties,
                              functionYear: e.target.value as string,
                            },
                          })
                        }
                        options={YEAR_OPTIONS}
                      />
                    </Box>
                  </Stack>

                  <EventTypeAutoSearch
                    fullWidth
                    label="Select Event Type"
                    multiple
                    value={
                      filterLocalState.otherCustomStateProperties
                        .searchByEventType || []
                    }
                    onSelect={(eventTypes) =>
                      setFilterlocalState({
                        ...filterLocalState,
                        otherCustomStateProperties: {
                          ...filterLocalState.otherCustomStateProperties,
                          searchByEventType: eventTypes,
                        },
                      })
                    }
                    isHighlighted={
                      (
                        filterLocalState.otherCustomStateProperties
                          .searchByEventType || []
                      ).length > 0
                    }
                  />

                  {(
                    filterLocalState.otherCustomStateProperties
                      .searchByEventType || []
                  ).includes("OTHER SOCIAL" as any) && (
                    <CustomTextField
                      variant="outlined"
                      fullWidth
                      placeholder="Search by Event Name"
                      value={
                        filterLocalState.otherCustomStateProperties
                          .other_event_name
                      }
                      onChange={(e) =>
                        setFilterlocalState({
                          ...filterLocalState,
                          otherCustomStateProperties: {
                            ...filterLocalState.otherCustomStateProperties,
                            other_event_name: e.target.value,
                          },
                        })
                      }
                    />
                  )}
                </Stack>
              </Box>

              <Divider sx={{ borderColor: "#f1f5f9" }} />

              {/* Section 3: Status & Attribution */}
              <Box>
                <Typography
                  variant="subtitle2"
                  fontWeight={700}
                  sx={{
                    color: "#334155",
                    fontSize: "0.85rem",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                    mb: 1.25,
                  }}
                >
                  Status & Attribution
                </Typography>
                <Stack spacing={2}>
                  <LeadSourceAutoSearch
                    label="Search by Source"
                    value={
                      filterLocalState.otherCustomStateProperties
                        .searchByLeadSource?.lead_source_uuid || ""
                    }
                    source_name={
                      filterLocalState.otherCustomStateProperties
                        .searchByLeadSource?.source_name || ""
                    }
                    onSelect={(ls) =>
                      setFilterlocalState({
                        ...filterLocalState,
                        otherCustomStateProperties: {
                          ...filterLocalState.otherCustomStateProperties,
                          searchByLeadSource: ls?.lead_source_uuid ? ls : null,
                        },
                      })
                    }
                    hideAddButton={true}
                    isHighlighted={
                      !!filterLocalState.otherCustomStateProperties
                        .searchByLeadSource?.lead_source_uuid
                    }
                  />

                  <CustomDatePicker
                    fullWidth
                    placeholder="Follow-up Date"
                    value={
                      filterLocalState.otherCustomStateProperties.followupDate
                    }
                    onChange={(newValue) =>
                      setFilterlocalState({
                        ...filterLocalState,
                        otherCustomStateProperties: {
                          ...filterLocalState.otherCustomStateProperties,
                          followupDate: newValue,
                        },
                      })
                    }
                  />

                  <MasterStatusAutoSearch
                    label="Select Status"
                    company_outlet_uuid={
                      companyOutlet.comapny.company_outlet_uuid
                    }
                    value={
                      filterLocalState.otherCustomStateProperties
                        .selectedTab !== "-1"
                        ? filterLocalState.otherCustomStateProperties
                            .selectedTab
                        : ""
                    }
                    onSelect={(nv) =>
                      setFilterlocalState({
                        ...filterLocalState,
                        otherCustomStateProperties: {
                          ...filterLocalState.otherCustomStateProperties,
                          selectedTab:
                            nv?.name && nv.name !== "All" ? nv.name : "-1",
                        },
                      })
                    }
                    placeholder="Search status..."
                    isHighlighted={
                      filterLocalState.otherCustomStateProperties
                        .selectedTab !== "-1"
                    }
                    showAllOption={true}
                  />

                  <PriorityFilter
                    isFilter
                    value={
                      filterLocalState.otherCustomStateProperties
                        .searchByPriority || ""
                    }
                    onChange={(val) =>
                      setFilterlocalState({
                        ...filterLocalState,
                        otherCustomStateProperties: {
                          ...filterLocalState.otherCustomStateProperties,
                          searchByPriority: val,
                        },
                      })
                    }
                    isHighlighted={
                      !!filterLocalState.otherCustomStateProperties
                        .searchByPriority
                    }
                  />
                </Stack>
              </Box>
            </Stack>
          )}
        </DataTableV2MobileFilter>
      ),
    },

    // ─── Mobile Columns ─────────────────────────────────────────────────────
    mobileColumns: [
      {
        variant: "template1",
        topBanner: {
          leftColumn: {
            key: "preferred_venue",
            fieldName: "preferred_venue",
            onRowCellRender: (_value: any, row: ILead) => (
              <Chip
                label={row.preferred_venue || "No Venue"}
                size="small"
                sx={{
                  height: 20,
                  fontSize: "0.685rem",
                  fontWeight: 700,
                  bgcolor: row.preferred_venue ? "#e0f2fe" : "#f1f5f9",
                  color: row.preferred_venue ? "#0369a1" : "#64748b",
                  borderRadius: "6px",
                  maxWidth: 160,
                }}
              />
            ),
          },
          rightColumn: {
            key: "event_detail",
            fieldName: "event_time",
            onRowCellRender: (_value: any, row: ILead) => {
              const eventTime = row.event_time || "";
              const eventName =
                row.other_event_name || row.event_name || row.event_type || "";
              const eventDetail = [eventTime, eventName]
                .filter(Boolean)
                .join(" | ");

              return (
                <Typography
                  variant="caption"
                  sx={{
                    color: "#64748b",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                  }}
                >
                  {eventDetail || ""}
                </Typography>
              );
            },
          },
        },
        headingColumn: {
          key: "name_of_guest",
          fieldName: "name_of_guest",
          onRowCellRender: (_value: any, row: ILead) => (
            <Typography
              variant="subtitle1"
              fontWeight={700}
              sx={{ color: "#0f172a", fontSize: "0.95rem", lineHeight: 1.25 }}
            >
              {row.name_of_guest || "Lead"}
            </Typography>
          ),
        },
        rightHeadingColumn: {
          key: "status",
          fieldName: "status",
          onRowCellRender: () => null,
        },
        subSectionColumn: [
          {
            key: "contact_number_one",
            fieldName: "contact_number_one",
            onRowCellRender: (_value: any, row: ILead) => (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  mt: 0.25,
                }}
              >
                {renderMobileContactCell(row)}

                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                  <CustomChip
                    color={
                      row.priority?.toUpperCase() === "HOT"
                        ? "error"
                        : row.priority?.toUpperCase() === "WARM"
                          ? "warning"
                          : "info"
                    }
                    content={row.priority || "COLD"}
                    size="small"
                  />
                  <LeadStatusRenderer
                    status={row.status || ""}
                    actualStatus={row.actual_status || ""}
                  />
                </Box>
              </Box>
            ),
          },
          {
            key: "assigned_and_followup",
            fieldName: "followup_date",
            onRowCellRender: (_value: any, row: ILead) => {
              const assignedUser =
                (row as any).assigned_to || row.handled_by_employee;
              const followupStr = row.followup_date
                ? moment(row.followup_date).format("DD-MMM-YYYY")
                : null;

              return (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    mt: 0.25,
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#64748b",
                      fontSize: "0.775rem",
                      fontWeight: 500,
                    }}
                  >
                    {assignedUser ? `Assigned: ${assignedUser}` : ""}
                  </Typography>

                  {followupStr && (
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#0284c7",
                        fontSize: "0.75rem",
                        fontWeight: 600,
                      }}
                    >
                      Follow up: {followupStr}
                    </Typography>
                  )}
                </Box>
              );
            },
          },
        ],
        otherColumns: [
          {
            key: "preferred_venue",
            fieldName: "preferred_venue",
            headerName: "Preferred Venue",
          },
          {
            key: "event_type",
            fieldName: "event_type",
            headerName: "Event Type",
          },
          {
            key: "function_date",
            fieldName: "function_date",
            headerName: "Event Date",
            onRowCellRender: (_v, row: ILead) => renderEventDate(row),
          },
          {
            key: "followup_date",
            fieldName: "followup_date",
            headerName: "Follow-up Date",
            onRowCellRender: (_v, row: ILead) => renderFollowupDate(row),
          },
        ],
        actions: [
          {
            name: "Quick Edit",
            icon: <EditNoteIcon />,
            click: (r: ILead) => setOpenEdit(r),
          },
          {
            name: "Edit",
            icon: <EditIcon />,
            click: (r: ILead) =>
              navigate(
                `${REACT_APP_NAV_ROUTES.leads.EventLeads}/manage/${r.leads_uuid}/${r.multiple_events_uuid}`,
              ),
          },
          {
            name: "History",
            icon: <HistoryIcon />,
            click: (r: ILead) => setOpenHistory(r),
          },
          ...(accessibleModuleIds.includes(ALLOWED_MODULES.PAYMENT_TRANSACTION)
            ? [
                {
                  name: "Quotation",
                  icon: <AccountBalanceWalletIcon />,
                  click: (r: ILead) => handleRoughEstimateClick(r),
                  hide: (r: ILead) =>
                    r.actual_status === "DEAD" ||
                    r.actual_status === "CANCELLED",
                },
              ]
            : []),
          {
            name: "Whatsapp",
            icon: <WhatsAppIcon />,
            click: (r: ILead) => setOpenWhatsapp(r),
          },
          {
            name: "Food Menu",
            icon: <RestaurantMenuIcon />,
            click: (r: ILead) => setOpenFoodMenu(r),
          },
          {
            name: "Delete",
            icon: <DeleteOutline sx={{ color: "error.main" }} />,
            click: (r: ILead) => setLeadToDelete(r),
          },
        ],
      },
    ],

    // ─── Desktop Columns ────────────────────────────────────────────────────
    masterColumns: [
      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        isFirstColumnSticky: true,
        width: "220px",
        minWidth: 230,
        onRowCellRender: (_v, row: ILead) => (
          <Box sx={{ display: "flex", gap: 1 }}>
            <StandardTableActions
              commentBoxTypeId={row.leads_uuid as string}
              onQuickEditClick={() => setOpenEdit(row)}
              onEditClick={() =>
                navigate(
                  `${REACT_APP_NAV_ROUTES.leads.EventLeads}/manage/${row.leads_uuid}/${row.multiple_events_uuid}`,
                )
              }
              onLeadFoodMenuClick={() => setOpenFoodMenu(row)}
              onViewHistoryClick={() => setOpenHistory(row)}
              onWhatsappClick={() => setOpenWhatsapp(row)}
              onRoughEstimationClick={() => handleRoughEstimateClick(row)}
              more={{
                menuItems: [
                  ...(row.actual_status === "BOOKED"
                    ? [
                        {
                          icon: <TrendingUp />,
                          label: "Upsell",
                          onClick: () =>
                            navigate("/upsell", { state: { leadData: row } }),
                        },
                      ]
                    : []),
                  {
                    icon: <ContentCopy fontSize="small" />,
                    label: "Copy Menu Link",
                    onClick: () => {
                      const url = `${config.domains.foodAppUrl}?outlet=${companyOutlet.comapny.company_outlet_uuid}`;
                      navigator.clipboard
                        .writeText(url)
                        .then(() =>
                          dispatch(
                            showMessage({
                              type: "success",
                              message: "Food menu link copied",
                              displayAs: "snackbar",
                            }),
                          ),
                        )
                        .catch(() =>
                          dispatch(
                            showMessage({
                              type: "error",
                              message: "Failed to copy link",
                              displayAs: "snackbar",
                            }),
                          ),
                        );
                    },
                  },
                  {
                    icon: <DeleteOutline sx={{ color: "error.main" }} />,
                    label: "Delete",
                    onClick: () => setLeadToDelete(row),
                  },
                ],
              }}
            />
          </Box>
        ),
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        enableSorting: true,
        width: "100px",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        minWidth: 100,
        onRowCellRender: (_v, row: ILead) => renderStatusChip(row),
      },
      {
        key: "priority",
        headerName: "Priority",
        fieldName: "priority",
        enableSorting: true,
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        width: "100px",
        minWidth: 100,
        onRowCellRender: (_value, row: ILead) => {
          if (!row.priority) return "--";
          const isHigh = row.priority.toUpperCase() === "HOT";
          return (
            <CustomChip
              content={isHigh ? "Hot" : "Cold"}
              size="small"
              sx={{
                color: isHigh ? "#d32f2f" : "#0288d1",
                bgcolor: isHigh ? "#ffebee" : "#e1f5fe",
                fontWeight: 600,
              }}
            />
          );
        },
      },
      {
        key: "name_of_guest",
        headerName: "Guest Name",
        fieldName: "name_of_guest",
        minWidth: 150,
        renderType: DataTableV2RowRenderType.TEXT_DARK,
        enableSorting: true,
      },
      {
        key: "contact_number_one",
        headerName: "Contact No",
        fieldName: "contact_number_one",
        width: "200px",
        type: "phone",
        renderType: DataTableV2RowRenderType.TEXT_DARK,

        enableSorting: true,
        minWidth: 200,
        onRowCellRender: (_v, row: ILead) => renderContactCell(row),
      },
      {
        key: "function_date",
        headerName: "Event Date",
        fieldName: "function_date",
        enableSorting: true,
        width: "110px",
        type: "date",
        minWidth: 100,
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (_v, row: ILead) => renderEventDate(row),
      },
      {
        key: "date_of_visit",
        headerName: "Date of Visit",
        fieldName: "date_of_visit",
        type: "date",
        enableSorting: true,
        width: "110px",
        minWidth: 110,
        renderType: DataTableV2RowRenderType.DATE_TIME,
        onRowCellRender: (_v, row: ILead) => ftDate(row.date_of_visit),
      },
      {
        key: "source",
        headerName: "Source",
        fieldName: "source",
        width: "130px",
        enableSorting: true,
        minWidth: 130,
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (_v, row: ILead) => (
          <SourceEventChip
            eventType={row.source || "--"}
            otherEventName={row.source || "--"}
          />
        ),
      },
      {
        key: "event_type",
        headerName: "Event Type",
        fieldName: "event_type",
        width: "150px",
        enableSorting: true,
        minWidth: 150,
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (_v, row: ILead) => (
          <EventChip
            eventType={row.event_type}
            otherEventName={row.other_event_name || ""}
          />
        ),
      },
      {
        key: "event_time",
        headerName: "Event Time",
        fieldName: "event_time",
        width: "100px",
        enableSorting: true,
        minWidth: 100,
        renderType: DataTableV2RowRenderType.TEXT,
        // onRowCellRender: (_v, row: ILead) => <EventChip eventType={row.event_time} />,
      },
      {
        key: "followup_date",
        headerName: "Follow-up Date",
        fieldName: "followup_date",
        type: "date",
        width: "130px",
        minWidth: 130,
        enableSorting: true,
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (_v, row: ILead) => renderFollowupDate(row),
      },
      {
        key: "preferred_venue",
        headerName: "Preferred Venue",
        fieldName: "preferred_venue",
        renderType: DataTableV2RowRenderType.TEXT_DARK,
        width: "130px",
        enableSorting: true,
        minWidth: 130,
      },

      {
        key: "handled_by_employee",
        headerName: "Handled By Employee",
        fieldName: "handled_by_employee",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        width: "160px",
        enableSorting: true,
        minWidth: 160,
      },
      {
        key: "create_ts",
        headerName: "Created At",
        fieldName: "create_ts",
        type: "date",
        enableSorting: true,
        width: "180px",
        minWidth: 180,
        renderType: DataTableV2RowRenderType.DATE_TIME,
        onRowCellRender: (_v, row: ILead) => ftDateTime(row.create_ts),
      },
    ],

    rows: list,
    tableTabProps: isDashboard
      ? undefined
      : {
          selectedTab: tabs.selectedTab,
          tabs: tabs.tabs,
          loading: recordCountsLoading !== LoadState.Loaded,
          onTabChange: setSelectedTab,
        },
    onPageChange,
    onRowsPerPageChange,
    onSelection: (_isAllSelected: boolean, rows: ILead[]) =>
      setSelectedLeads(rows),
    masterColumnResize: {
      values: masterColumnResize,
      onResize: onResizeMasterColumns,
    },
    // rowHighlightCondition: (row) => {
    //   if (row.priority === "HIGH") return "#fed13fb0"; // light orange for high priority
    //   return undefined;
    // },
  };

  // ─── Effects ──────────────────────────────────────────────────────────────

  React.useEffect(() => {
    fetchList();
  }, [
    pagination.pageNumber,
    pagination.rowsInPerPage,
    tabs.selectedTab,
    searchState,
    dateState,
    debouncedSearchNameOrNumber,
    searchVersion,
    debouncedSearchVenue,
    debouncedEventName,
    otherCustomStateProperties.followupDate,
    otherCustomStateProperties.functionDate,
    otherCustomStateProperties.searchByEventType,
    otherCustomStateProperties.searchByIsReplied,
    otherCustomStateProperties.functionMonth,
    otherCustomStateProperties.functionYear,
    otherCustomStateProperties.searchByLeadSource?.lead_source_uuid,
    otherCustomStateProperties.searchByPriority,
    dashboardConfig?.statusParam,
    dashboardConfig?.monthType,
    dashboardConfig?.dateState,
  ]);

  // Dashboard: scroll the table into view whenever a different count card is picked.
  React.useEffect(() => {
    if (!isDashboard) return;
    if (tableRef.current && !isInitialLoad.current) {
      const topOffset = 90;
      const elementPosition =
        tableRef.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - topOffset,
        behavior: "smooth",
      });
    } else {
      isInitialLoad.current = false;
    }
  }, [dashboardConfig?.statusParam]);

  React.useEffect(() => {
    if (isDashboard) return;
    dispatch(
      fetchRecordCountsAsync({
        tableName: "latest_leads",
        module_key: ALLOWED_MODULES.EVENT_LEADS,
        fromDate: dateState.dates.fromDate,
        toDate: dateState.dates.toDate,
        companyOutlet: companyOutlet.comapny.company_outlet_uuid,
        searchValue: getFilters(),
      }),
    );
  }, [
    dateState.dates.fromDate,
    dateState.dates.toDate,
    debouncedSearchNameOrNumber,
    searchVersion,
    debouncedSearchVenue,
    debouncedEventName,
    otherCustomStateProperties.followupDate,
    otherCustomStateProperties.functionDate,
    otherCustomStateProperties.searchByEventType,
    otherCustomStateProperties.searchByIsReplied,
    otherCustomStateProperties.functionMonth,
    otherCustomStateProperties.functionYear,
    otherCustomStateProperties.searchByLeadSource?.lead_source_uuid,
    otherCustomStateProperties.searchByPriority,
    companyOutlet.comapny.company_outlet_uuid,
  ]);

  React.useEffect(() => {
    return () => {
      if (!isDashboard) dispatch(clearRecordCounts());
      dispatch(clearLeadsState());
    };
  }, []);
  React.useEffect(() => {
    setTableTabs(createTabsWithRecordcountsV2(recordsCounts));
  }, [recordsCounts]);

  React.useEffect(() => {
    if (companyOutlet.comapny.company_outlet_uuid) {
      dispatch(
        fetchDriveStatusCategoryListAsync(
          companyOutlet.comapny.company_outlet_uuid,
        ),
      );
    }
  }, [companyOutlet.comapny.company_outlet_uuid]);

  // ─── Render ───────────────────────────────────────────────────────────────

  const content = (
    <>
      <DataTableV2 stickyHeader {...leadsTableProps} />

      {openView && (
        <ViewLeadDetails
          open
          lead={openView}
          onClose={() => setOpenView(null)}
        />
      )}

      {openEdit && (
        <EditLeadDetails
          open
          title="Edit Lead Details"
          leadDetails={openEdit}
          onClose={() => setOpenEdit(null)}
          onComplete={() => {
            setOpenEdit(null);
            fetchList();
          }}
          onCancelSuccess={() => {
            setOpenEdit(null);
            fetchList();
          }}
        />
      )}

      {openRoughEstimate && (
        <RightPanel
          open
          heading="Quick Quotation"
          width="95%"
          onClose={() => setRoughEstimate(null)}
        >
          <ManageRoughEstimate
            leadUUID={openRoughEstimate.leads_uuid || ""}
            initialLeadToRoughEstimate={openRoughEstimate}
            eventLeadsOptions={eventOptionsForPaymentDetails}
            onSave={fetchList}
            skipInitialFetch
          />
        </RightPanel>
      )}

      {openWhatsapp && (
        <ViewWhatsappDetails
          open
          onClose={() => setOpenWhatsapp(null)}
          leadDetails={openWhatsapp}
        />
      )}

      <DialerCallDialog
        open={dialerState.open}
        type={dialerState.type}
        message={dialerState.message}
        onClose={closeDialog}
      />

      {openHistory && (
        <ViewHistoryDetailsRightPanel
          open
          onClose={() => setOpenHistory(null)}
          moduleInformation={{
            moduleId: openHistory.leads_uuid,
            moduleName: MODULE_NAMES.LEADS,
            subModuleName: MODULE_NAMES.LEADS,
            refColumnName: "leads_uuid",
          }}
        />
      )}

      {openFoodMenu && (
        <OrderProvider type="LEAD" leadUuid={openFoodMenu.leads_uuid || ""}>
          <ViewLeadFoodMenuRightPanel
            selectedLeadData={openFoodMenu}
            open
            leadUuid={openFoodMenu.leads_uuid || ""}
            multipleEventsUuid={openFoodMenu.multiple_events_uuid || ""}
            onClose={() => setOpenFoodMenu(null)}
          />
        </OrderProvider>
      )}

      {openQuickEdit && (
        <QuickEditLead
          leadDetails={openQuickEdit}
          open
          onClose={() => setOpenQuickEdit(null)}
        />
      )}

      {openEditCustomer && (
        <EditCustomerRightPanel
          open
          contact_number={openEditCustomer.contact_number_one}
          onClose={() => {
            setOpenEditCustomer(null);
            dispatch(clearStudent());
          }}
          onComplete={() => {
            setOpenEditCustomer(null);
            fetchList();
            dispatch(clearStudent());
          }}
        />
      )}

      {assignUserDialogOpen && (
        <AssignUserDialog
          open={assignUserDialogOpen}
          onClose={() => setAssignUserDialogOpen(false)}
          selectedLeads={selectedLeads}
          onComplete={handleAssignUserComplete}
        />
      )}

      {leadToDelete && (
        <ConfirmDialog
          open={Boolean(leadToDelete)}
          content="Are you sure you want to delete this lead?"
          onClose={() => setLeadToDelete(null)}
          onConfrim={() => {
            handleDeleteLead(leadToDelete);
            setLeadToDelete(null);
          }}
        />
      )}

      <Snackbar
        open={Boolean(deleteErrorMsg)}
        autoHideDuration={6000}
        onClose={() => setDeleteErrorMsg(null)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ zIndex: 99999 }}
      >
        <Alert
          onClose={() => setDeleteErrorMsg(null)}
          severity="error"
          variant="filled"
          sx={{
            width: "100%",
            maxWidth: 750,
            fontSize: "1.2rem",
            fontWeight: 600,
            borderRadius: 3,
            boxShadow: "0px 8px 30px rgba(0,0,0,0.25)",
            p: "16px 28px",
          }}
        >
          {deleteErrorMsg}
        </Alert>
      </Snackbar>

      {openBulkUpload && (
        <BulkUploadLeadsRightPanel
          open={openBulkUpload}
          onClose={() => setOpenBulkUpload(false)}
          onSuccess={() => {
            fetchList();
          }}
          moduleName="LEADS"
          tableName="latest_leads"
        />
      )}
    </>
  );

  // Dashboard embeds the table, so skip PageContainer (it would override the page title).
  if (isDashboard) {
    return <Box ref={tableRef}>{content}</Box>;
  }

  return (
    <PageContainer title="View Leads" description="this is innerpage">
      {content}
    </PageContainer>
  );
};
